import { createStore } from 'vuex';
import { getCookie, setCookie, deleteAllCookies } from '../cookies';
import axios from '../axios';
import dayjs from 'dayjs';


const store = createStore({
  state() {
    return {
      disablePlaylistOnNetworkType:  process.env.VUE_APP_PLAYLIST_DISABLED_ON_NETWORK_TYPE || [],
      disablePlaylistWhenSaveDataEnabled: process.env.VUE_APP_PLAYLIST_DISABLED_WHEN_SAVE_DATA_ENABLED  === "true" || false,
      networkQuality: true,

      logos: {},

      imagesAlreadyLoaded: false,
      images: [],
      lastRefreshedDateTime: dayjs(),

      refreshAriaEventMessage: '',
      customer: process.env.VUE_APP_CUSTOMER_ID,
      pageTitle: '',

      services: null,
      messages: [],
      rawMessages: [],
      loadingData: false,
      error: null,

      qRCodePrefix: process.env.VUE_APP_NAPTAN_PREFIX,
      qRVirtualCodePrefix: process.env.VUE_APP_VIRTUAL_CODE_PREFIX,
      appRemovesFirstThreeCharactersFromNapTAN: process.env.VUE_APP_REMOVE_FIRST_THREE_CHARACTERS_FROM_NAPTAN,


      playlistEnabled: process.env.VUE_APP_PLAYLIST_SCREEN_ENABLED === "true",
      numberOfServicesToDisplay: parseInt(process.env.VUE_APP_SERVICES_TO_DISPLAY, 10),


      repressServices: false,

      currentPage: 'timetable',

      highContrastEnabled: getCookie('highContrast') === '1',
      audioEnabled: false,
      selectedLanguage: 'en',


      splashScreenViewed: false,
      splashScreenIdLastViewed: false,
      canUseCookies: false,
      disableMenu: false,

      popupMinimised: false,
      popupPreviouslyMinimised: false,

      dismissCountdownShownForMessageId: null,
      lastDisplayedMessageId: null,

      AppClock: new Date(),

      qRCode: '',
      isHealthCheckRequest: false,
      stopDescription: {
        naptanCode: '',
        atcoCode: '',
        commonName: '',
        indicator: '',
        street: '',
        localityName: '',
      },
      multiStop: false,
      digitalCodeDescription: '',
      digitalCodeDescriptionCy: '',
      playlist: {id: null},
      links: [
        { title: "TfW", url: "https://tickets.tfw.wales/" },
        { title: "TrawsCymru", url: "https://traws.cymru/en" },
        { title: "fflecsi", url: "https://tfw.wales/fflecsi" },
        { title: "National Express", url: "https://international.nationalexpress.com/" },
      ],
    };
  },
  getters: {
    notSeenCurrentSplashScreen(state) {
      return !state.splashScreenViewed && (state.splashScreenIdLastViewed !== state.playlist.id)
    },
    splashIdSameCookieValue(state) {
      return state.splashScreenIdLastViewed == state.playlist.id;
    },
    displayPlaylistScreen(state, getters) {

      //if not enabled always return false
      if (!state.playlistEnabled) return false
      
      //if current page is splash screen return true
      if(state.currentPage === 'playlist-screen') return true

      //if no playlists to play return false
      if (!state.playlist || state.playlist.playlistItems  == null || state.playlist.playlistItems.length < 1) return false;      
      
      if (!state.networkQuality) return false;

      //if splash screen has not been Viewed and splashId Not Same as Cookie Value return true
      if(getters.notSeenCurrentSplashScreen) return true

      return false;
    },

    stopDescription(state) {
      return state.stopDescription;
    },

    getDigitalCodeDescription(state) {
      return getDigitalCodeDescriptionText(
        state.digitalCodeDescription,
        state.digitalCodeDescriptionCy,
        state.selectedLanguage,
      );
    },

    getmessagesForQRCode(state) {
      const messages = state.messages && state.messages? state.messages : null;
      return messages;
    },
    getServiceForQRCode(state) {
      const services = state.services && state.services? state.services : null;
      return services;
    },
    cookiePreference(state) {
      let canUseCookies = localStorage.getItem("vue-cookie-accept-decline-cookiepreference");
      let newValue = false;
      newValue = canUseCookies == "accept" ? true : false;

      state.canUseCookies = newValue
      return newValue;
    },
    getHighestPriorityMessage(state) {
      let sortedMessages = [...state.messages].sort((a, b) => {
        return (
          a.priority - b.priority || b.type - a.type || new Date(b.dateTime) - new Date(a.dateTime)
        );
      });
  
      return (sortedMessages && sortedMessages.length > 0)
        ? sortedMessages[0]
        : null;
    }
  },
  mutations: {
    INITIALISE_LANGUAGE(state) {
      if (state.canUseCookies) {
        state.selectedLanguage = getCookie('selectedLanguage') || 'en'
      }
    },
    SET_LOGOS(state, value) {
      state.logos = value;      
    },
    SET_LASTREFRESHEDDATETIME(state, value) {
      state.lastRefreshedDateTime = value;
    },
    SET_TITLE(state, value)
    {
      document.title = value;
      state.pageTitle = value;
    },
    SET_STOP_DESCRIPTION(state, value) {
      state.stopDescription = value;
    },
    SET_DIGITAL_CODE_DESCRIPTION(state, value) {
      state.digitalCodeDescription = value;
    },
    SET_DIGITAL_CODE_DESCRIPTION_CY(state, value) {
      state.digitalCodeDescriptionCy = value;
    },
    SET_MULTI_STOP(state, value) {
      state.multiStop = value;
    },
    SET_PLAYLIST(state, value) {
      state.playlist = value;
    },
    SET_SERVICES(state, items) {
      state.services = items;
    },
    SET_MESSAGES(state, items) {
      state.messages = items;
    },
    SET_RAW_MESSAGES(state, items) {
      state.rawMessages = items;
    },
    SET_LOADING_DATA(state, loading) {
      state.loadingData = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_REFRESH_ARIA_EVENT_MESSAGE(state, message) {
      state.refreshAriaEventMessage = message;
    },
    setPopupMinimised(state, value)
    {
      state.popupMinimised = value;
    },
    setPopupPreviouslyMinimised(state, value)
    {
      state.popupPreviouslyMinimised = value;
    },
    setDismissCountdownShownForMessageId(state, value)
    {
      state.dismissCountdownShownForMessageId = value;
    },
    setLastDisplayedMessageId(state, value)
    {
      state.lastDisplayedMessageId = value;
    },
    setCurrentPage(state, value)
    {
      state.currentPage = value;
    },

    setRepressServices(state, value)
    {
      state.repressServices = value;
    },    
    setQRCode(state, value) {      
      if (value != null
        && state.appRemovesFirstThreeCharactersFromNapTAN
        && !value.startsWith(state.qRVirtualCodePrefix)) {
        state.qRCode = `${state.qRCodePrefix}${value}`        
      } else {    
        state.qRCode = `${value}`
      }
    },
    SET_IS_HEALTH_CHECK_REQUEST(state, value) {
      state.isHealthCheckRequest = value;
    },
    setAppClock(state, value) {
      state.AppClock = value;
    },
    setDisableMenu(state, value) {
      state.disableMenu = value;
    },    
    setContrast(state, value) {
      state.highContrastEnabled = value;
      if(state.canUseCookies) setCookie('highContrast', value ? '1' : '0', 365); 
    },    
    setAudio(state, value) {
      state.audioEnabled = value;
      if(state.canUseCookies) setCookie('audioEnabled', value ? '1' : '0', 365); 
    },
    setLanguage(state, value) {
      state.selectedLanguage = value === 'cy' ? 'cy' : 'en';
      if(state.canUseCookies) setCookie('selectedLanguage', state.selectedLanguage, 365);
    },
    setSplashScreenViewed(state) {
      state.splashScreenViewed = state.playlist.id;
      if(state.canUseCookies) setCookie('splashScreenViewed', state.playlist.id, 1);
    }, 
    setSplashScreenIdLastViewed(state, value) {
      state.splashScreenIdLastViewed = value;
      },    
    recreateAllCookies(state)
    {
      setCookie('highContrast', state.highContrastEnabled ? '1' : '0', 365)
      setCookie('audioEnabled', state.audioEnabled ? '1' : '0', 365)
      setCookie('selectedLanguage', state.selectedLanguage, 365)
      setCookie('splashScreenViewed', state.playlist.id, 1)
    },    
    deleteAllCookies()
    {
      deleteAllCookies()
    },    
    setCanUseCookies(state) {
      let canUseCookies = localStorage.getItem("vue-cookie-accept-decline-cookiepreference");
      let newValue = false;
      newValue = canUseCookies == "accept" ? true : false;

      state.canUseCookies = newValue
    },
    SET_IMAGES_ALREADY_LOADED(state, value) {
      state.imagesAlreadyLoaded = value;
    },
    SET_IMAGES(state, value) {
      state.images = value;
    },
    SET_NETWORK_QUALITY(state, value) {
      state.networkQuality = value;
    }
  },
  actions: {
    detectNetworkQuality({ commit, state }) {
      const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      
      // if API unsupported set to good
      if (!conn) {
        commit('SET_NETWORK_QUALITY', true); 
        return;
      }

      const isSlowNetwork = (!state.disablePlaylistOnNetworkType.includes( conn.effectiveType))
      
      const saveDateModeEnabledAndAllowed =
        (conn.saveData === true) && state.disablePlaylistWhenSaveDataEnabled

      const isGood = isSlowNetwork && !saveDateModeEnabledAndAllowed;    

      commit('SET_NETWORK_QUALITY', isGood);
    },
    async preloadImages({ commit }, images) {
      const promises = images.map((image) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = image;
          img.onload = () => resolve();
          img.onerror = () => reject(new Error(`Failed to load image: ${image}`));
        });        
      });
      
      
      return Promise.all(promises)
      .then(() => {
        // commit('SET_IMAGES', images);
        commit('SET_IMAGES_ALREADY_LOADED', true);
      })
      .catch((error) => {
        commit('SET_IMAGES_ALREADY_LOADED', true);
        console.error(error);
      });
    },
    async setTitle({ commit, state }) {
      const digitalCodeDescription = getDigitalCodeDescriptionText(
        state.digitalCodeDescription,
        state.digitalCodeDescriptionCy,
        state.selectedLanguage,
      );
      let title = state.multiStop ? digitalCodeDescription : state.stopDescription.commonName;
      commit('SET_TITLE', title);
    },
    async fetchData({ commit, state }) {
      commit('SET_LOADING_DATA', true);
      commit('SET_ERROR', null); 
      commit('SET_REFRESH_ARIA_EVENT_MESSAGE', '');

      try {
        if (!state.customer) throw Error('Missing customer parameter')
        if (!state.qRCode) throw Error('Missing Digital Code Id parameter')
        
        const response = await axios.post('/DCMS/data', {
          customer: state.customer,
          DigitalCodeId: state.qRCode,
          isHealthCheck: state.isHealthCheckRequest
        })
        const services = mapDeparturesToServices(response.data.departures || [])
        const rawMessages = response.data.messages || [];
        const messages = mapMessages(rawMessages, state.selectedLanguage);
        
        commit('SET_SERVICES', services);
        commit('SET_RAW_MESSAGES', rawMessages);
        commit('SET_MESSAGES', messages);
        commit('SET_STOP_DESCRIPTION', response.data.stopDescription  || {});        
        commit('SET_MULTI_STOP', response.data.multiStop ?? false);    
        commit('SET_DIGITAL_CODE_DESCRIPTION', response.data.digitalCodeDescription || '');
        commit('SET_DIGITAL_CODE_DESCRIPTION_CY', response.data.digitalCodeDescriptionCy || '');
        commit('SET_PLAYLIST', response.data.playlist || { id: null });
        
        if (response.data.playlist && response.data.playlist.id && !state.imagesAlreadyLoaded && state.networkQuality) {
          await store.dispatch('preloadImages', response.data.playlist.playlistItems.map(item => item.src));
        }        
        store.dispatch('setTitle')        
      }  catch (error) {
        console.error(error);
        commit('SET_ERROR', 'Failed to fetch data');
      } finally {
        commit('SET_LOADING_DATA', false);
        commit('SET_REFRESH_ARIA_EVENT_MESSAGE', 'refreshButton.dataReloaded');
      }

    },
    async fetchLogos({ commit, state }) {
      if (Object.keys(state.logos).length > 0) return;
      try {
        if (!state.customer) throw Error('Missing customer parameter')
        const response = await axios.get(`/DCMS/serviceLogos?customerId=${state.customer}`)
        commit('SET_LOGOS', response.data);
      } catch (error) {
        console.error('Failed to fetch logos');
      }
    },

    updateLastRefreshedDateTime({ commit }, payload) 
    {      
      commit('SET_LASTREFRESHEDDATETIME', payload)
    },
    updatePopupMinimised({ commit }, payload) 
    {      
      commit('setPopupMinimised', payload)
      if(payload == true) commit('setPopupPreviouslyMinimised', payload)
    },
    updateCurrentPage({ commit }, payload) {
      //commit('setRepressServices', false)
      commit('setCurrentPage', payload)
    },
    updateDismissCountdownShownForMessageId({ commit }, payload) {
      commit('setDismissCountdownShownForMessageId', payload)
    },
    updateLastDisplayedMessageId({ commit }, payload) {
      commit('setLastDisplayedMessageId', payload)
    },
    updateRepressServices({ commit }, payload) {      
      commit('setRepressServices', payload)
    },

    updateContrast({ commit }, payload) {
      commit('setContrast', payload);
    },
    updateAudio({ commit }, payload) {
      commit('setAudio', payload);
    },
    updateLanguage({ commit, dispatch, state }, payload) {
      const language = payload === 'cy' ? 'cy' : 'en';
      commit('setLanguage', language);
      commit('SET_MESSAGES', mapMessages(state.rawMessages || [], language));
      dispatch('setTitle');
    },
    updateSplashScreenViewed({ commit }) {
      commit('setSplashScreenViewed');
    },
    initializeStore({ commit }) {
      const contrastCookie = getCookie('highContrast');
      const audioCookie = getCookie('audioEnabled');
      const selectedLanguageCookie = getCookie('selectedLanguage');
      const splashScreenIdLastViewedCookie = getCookie('splashScreenViewed');
      if (contrastCookie !== null) {
        commit('setContrast', contrastCookie === '1');
      }
      if (audioCookie !== null) {
        commit('setAudio', audioCookie !== '0');
      }
      if (selectedLanguageCookie !== null) {
        commit('setLanguage', selectedLanguageCookie === 'cy' ? 'cy' : 'en');
      }
      if (splashScreenIdLastViewedCookie !== null) {
        commit('setSplashScreenIdLastViewed', splashScreenIdLastViewedCookie);
      }
      commit('setCanUseCookies')
      commit('INITIALISE_LANGUAGE')
    },
    setIsHealthCheckRequest({ commit }, payload) {
      commit('SET_IS_HEALTH_CHECK_REQUEST', payload)
    }
  },
});

// Initialize store immediately 
store.dispatch('initializeStore');

function mapDeparturesToServices(departures) {
  return departures.map(departure => ({
    id: departure.id || Math.random() * 10000000000000000, // generate an id if not present
    service: departure.lineName,
    destination: departure.destination,
    destinationEN: departure.destinationEN,
    destinationCY: departure.destinationCY,
    startStopATCOCode: departure.originRef,
    ATCOCode: departure.monitoredStopRef,
    endStopATCOCode: departure.destinationRef,
    due: new Date(departure.expectedDepartureTime),
    monitored: departure.monitored,
    monitoredStopDescription: departure.monitoredStopDescription,
    aimedDepartureTime: new Date(departure.aimedDepartureTime + "Z"),
    provider: departure.operatorRef,
    providerName: departure.operatorName,
    providerImageSrc: departure.operatorImageSrc,
    serviceMessage: departure.status,
    orderedByTime: departure.OrderedByTime,
    vehicleRef: departure.vehicleRef,
    via: departure.callingPoints.map(point => ({
      stopName: point.stopName,
      stopNameCY: point.stopNameCY,
      stopDue: new Date(point.stopDue),
      estimatedMinutesToStop: point.estimatedMinutesToStop,
      isTimingPoint: point.isTimingPoint,
      stopOrder: point.stopOrder
    })),
  }));
}

function mapMessages(messages, language) {
  const selectedLanguage = language === 'cy' ? 'cy' : 'en';
  let mappedMessages = messages.map(message => ({
    id: message.id,
    type: message.messageLocation,
    priority: message.messagePriority,
    dateTime: message.dateCreated,
    text: getMessageText(message.messageText || [], selectedLanguage),
  }));

  return mappedMessages;
}

function getDigitalCodeDescriptionText(description, descriptionCy, language) {
  if (language?.toLowerCase() === 'cy' && descriptionCy) return descriptionCy;
  return description || '';
}

function getMessageText(messageText, language) {
  const selected = messageText.find(x => x.lang?.toLowerCase() === language?.toLowerCase());
  if (selected && selected.text) return selected.text;

  const fallbackEnglish = messageText.find(x => x.lang?.toLowerCase() === 'en');
  if (fallbackEnglish && fallbackEnglish.text) return fallbackEnglish.text;

  return messageText.length > 0 && messageText[0].text ? messageText[0].text : '';
}

export default store;
